import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {useBreakpointDown} from '@travel-frontend/core';
import {LayoutContainer as LayoutContainerUI} from '@travel-frontend/ui-components';
import {forwardRef} from 'react';

type LayoutContainerProps = React.ComponentProps<typeof LayoutContainerUI>;

const CustomLayoutContainer = styled(LayoutContainerUI)<
  {
    isFullWidth: boolean;
  } & LayoutContainerProps
>`
  position: relative;

  [data-layout-container-outset] {
    ${({isFullWidth}) =>
      isFullWidth &&
      css`
        margin: 0 calc(var(--layout-container-padding) * -1);
      `}
  }
`;

export const LayoutContainer = styled(
  forwardRef<HTMLDivElement, LayoutContainerProps>(
    function LayoutContainer(props, ref) {
      const lgDown = useBreakpointDown('lg');

      return (
        <CustomLayoutContainer {...props} ref={ref} isFullWidth={lgDown} />
      );
    }
  )
)``;
